<template>
    <div class="bg-white px-3 index" >
        <div class="add_tits" ref="title">
            <el-form class="form-inlines">
                <el-form-item>
                    <el-button size="small" @click="addpart()" type="primary">新增</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div class="ibox-content">
            <el-table :data="tableData" :height="heights" ref="topicTable" row-key="id" border
                :tree-props="{ children: 'children' }" tooltip-effect="dark" v-loading="loading">
                <el-table-column prop="name" label="诊疗中心">
                    <template slot-scope="scope">
                        <span @click="handleConnectionSearch(scope.row)"
                            style="cursor: pointer">{{ scope.row.name }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="sort" label="排序">
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.sort" @blur="Losed(scope.row)" size="mini" class="tab_inp"
                            type="number" placeholder="请输入内容">
                        </el-input>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="250">
                    <template slot-scope="scope">
                        <el-button size="mini" type="primary" @click="handleEdit(scope.$index, scope.row)">编辑
                        </el-button>
                        <el-button size="mini" type="primary" @click="handlechild(scope.$index, scope.row)">添加子类
                        </el-button>
                        <el-button size="mini" type="danger" @click="handleDelete(scope.$index, scope.row)">删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <!-- 新增 -->
        <el-dialog title="新增诊疗中心" :visible.sync="dialogAdd" top="60px"  class="dialogs" center>
            <el-divider></el-divider>
            <div class="dialog-ibox-content">
                <el-form label-width="120px" :rules="rules" :model="ruleForm" ref="ruleForm">
                    <el-form-item label="诊疗中心名称" prop="Addname">
                        <el-input v-model="ruleForm.Addname" size="small" class="tab_inp"></el-input>
                    </el-form-item>
                    <el-form-item label="诊疗中心排序" prop="Addsort">
                        <el-input v-model.number="ruleForm.Addsort" size="small" class="tab_inp"></el-input>
                    </el-form-item>
                    <el-form-item label="图标" >
                        <el-upload  action="/admin/uploadFile" name="img" ref="upload" 
                            :headers="{ 'token':$store.state.user.token }" 
                            :data="{ image_class_id:'2',file_type:'1', }"  :on-preview="handlePictureCardPreview"
                            :file-list="ruleForm.lb_mapList"  :on-success="uploadSuccess"
                            :limit="1" :on-remove="uploadRmove" list-type="picture-card">
                            <i class="el-icon-plus"></i>
                        </el-upload>
                    </el-form-item>
                    <el-form-item label="上级诊疗中心">
                        <el-input v-model="filterText" size="small" class="tab_inp" @input="search"></el-input>
                        <div class="dia_over">
                            <div class="dia_mg">
                                <el-tree :data="data" class=" listtree" :props="defaultProps"
                                    :default-expanded-keys="openkeys" @node-click="getnodeclick" highlight-current
                                    ref="tree" node-key="id">
                                </el-tree>
                            </div>
                        </div>
                    </el-form-item>
                </el-form>
            </div>
            <el-divider></el-divider>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" size="small"  :loading="subLoading" @click="addsub('ruleForm')">提 交</el-button>
                <el-button size="small" @click="dialogAdd = false">取 消</el-button>
            </span>
        </el-dialog>
        <!-- 编辑 -->
        <el-dialog title="编辑诊疗中心" :visible.sync="dialogEdit"  top="60px"  class="dialogs" center>
            <el-divider></el-divider>
            <div class="dialog-ibox-content">
                <el-form label-width="120px" :rules="ruled" :model="ruleFormed" ref="ruleFormed">
                    <el-form-item label="诊疗中心名称" prop="Editname">
                        <el-input v-model="ruleFormed.Editname" size="small" class="tab_inp"></el-input>
                    </el-form-item>
                    <el-form-item label="诊疗中心排序" prop="Editsort">
                        <el-input v-model.number="ruleFormed.Editsort" size="small" class="tab_inp">
                        </el-input>
                    </el-form-item>
                     <el-form-item label="图标" >
                        <el-upload  action="/admin/uploadFile" name="img" ref="uploads"  :on-preview="handlePictureCardPreview"
                            :headers="{ 'token':$store.state.user.token }" :data="{ image_class_id:'2',file_type:'1', }"
                            :file-list="ruleFormed.lb_mapList"  :on-success="uploadSuccessed" 
                            :limit="1" :on-remove="uploadRmoved" list-type="picture-card">
                            <i class="el-icon-plus"></i>
                        </el-upload>
                    </el-form-item>
                    <el-form-item label="上级诊疗中心">
                        <el-input v-model="filterTexted" size="small" class="tab_inp" @input="searched"></el-input>
                        <div class="dia_over">
                            <div class="dia_mg">
                                <el-tree :data="dataed" class="listtree" :props="defaultProps" highlight-current
                                    :default-expanded-keys="openkeysed" default-expand-all @node-click="getnodeclicked"
                                    ref="treed" node-key="id"></el-tree>
                            </div>
                        </div>
                    </el-form-item>
                </el-form>
            </div>
            <el-divider></el-divider>
            <span slot="footer" class="dialog-footer">
                <el-button size="small" type="primary" :loading="subloadings" @click="Editsub('ruleFormed')">提 交</el-button>
                <el-button size="small" @click="dialogEdit = false">取 消</el-button>
            </span>
        </el-dialog>
        <!-- 添加子诊疗中心 -->
        <el-dialog title="添加子诊疗中心" :visible.sync="dialogchild" width="40%"  class="dialogs">
            <el-divider></el-divider>
            <div class="dialog-ibox-content">
                <el-form label-width="120px" :rules="ruler" :model="ruleFormer" ref="ruleFormer">
                    <el-form-item label="上级诊疗中心">
                        <span>{{ chil_name }}</span>
                    </el-form-item>
                    <el-form-item label="诊疗中心名称" prop="childname">
                        <el-input v-model="ruleFormer.childname" size="small" class="tab_inp"></el-input>
                    </el-form-item>
                    <el-form-item label="诊疗中心排序" prop="childsort">
                        <el-input v-model.number="ruleFormer.childsort" size="small" class="tab_inp">
                        </el-input>
                    </el-form-item>
                </el-form>
            </div>
            <el-divider></el-divider>
            <span slot="footer" class="dialog-footer">
                <el-button size="small" @click="dialogchild = false">取 消</el-button>
                <el-button size="small" type="primary" @click="Editchildsub('ruleFormer')">提 交</el-button>
            </span>
        </el-dialog>

        <el-dialog :visible.sync="dialogVisible">
            <img width="100%" :src="dialogImageUrl" alt="">
        </el-dialog>
    </div>
</template>


<script>
    import {
        mapState
    } from 'vuex'
    export default {
        data() {
            return {
                loading: false,
                tableData: [],
                heights: null,
                dialogAdd: false,
                multipleSelection: [],
                dialogEdit: false,
                ruleForm: {
                    Addtop: "",
                    Addname: "",
                    Addsort: "",
                    lb_mapList:[],
                },
                mapListed:[],
                subLoading:false,
                rules: {
                    Addname: [{
                        required: true,
                        message: "诊疗中心名称不能为空",
                        trigger: "blur",
                    }, ],

                    Addsort: [{
                            required: true,
                            message: "诊疗中心排序不能为空",
                        },
                        {
                            type: "number",
                            message: "诊疗中心排序必须为数字值",
                        },
                    ],
                },
                ruleFormed: {
                    Edittop: "",
                    Editname: "",
                    Editsort: "",
                    lb_mapList:[],
                },
                 mapListeder:[],
                 subloadings:false,
                ruled: {
                    Editname: [{
                        required: true,
                        message: "诊疗中心名称不能为空",
                        trigger: "blur",
                    }, ],
                    Editsort: [{
                            required: true,
                            message: "诊疗中心排序不能为空",
                        },
                        {
                            type: "number",
                            message: "诊疗中心排序必须为数字值",
                        },
                    ],
                },
                Addoptions: [],
                Editoptions: [],
                eid: "",
                defaultProps: {
                    children: "children",
                    label: "name",
                },
                filterText: "",
                data: [],
                openkeys: [],
                filterTexted: "",
                dataed: [],
                openkeysed: [],
                dialogchild: false,
                ruler: {
                    childname: [{
                        required: true,
                        message: "诊疗中心名称不能为空",
                        trigger: "blur",
                    }, ],
                    childsort: [{
                            required: true,
                            message: "诊疗中心排序不能为空",
                        },
                        {
                            type: "number",
                            message: "诊疗中心排序必须为数字值",
                        },
                    ],
                },
                ruleFormer: {
                    childname: "",
                    childsort: "",
                },
                childid: "",
                chil_name: "",
                child_id: "",

                // 
                dialogVisible:false,
                dialogImageUrl:''
            };
        },
        computed: {
            ...mapState({
                user: state => state.user.user,
            })
        },
        mounted() {
            let that = this;
            that.getHeight()
            that.begin()
        },
        methods: {
            // 获取高度
            getHeight() {
                let that = this;
                var title = that.$refs.title.offsetHeight
                that.heights = window.innerHeight - title - 175 + 'px'
                window.onresize = () => {
                    var title = that.$refs.title.offsetHeight
                    that.heights = window.innerHeight - title - 175 + 'px'
                }
            },
            //查询机构数据
            begin() {
                let that = this
                that.loading = true
                axios
                    .post("/admin/KkysKnowledgeDisease/showDiseaseList", {}, {
                        token: true
                    })
                    .then(response => {
                        if (response.data.code == '200') {
                            that.tableData = response.data.data
                            that.loading = false
                        } else {
                            this.$message.error(response.data.msg);
                        }
                    })
                    .catch(error => {})
            },
            //行点击事件
            handleConnectionSearch(row) {
                if (row.children.length > 0) {
                    this.$refs.topicTable.toggleRowExpansion(row)
                }
            },
            //失去焦点触发
            Losed(row) {
                let that = this
                axios
                    .post("/admin/KkysKnowledgeDisease/sortRecord", {
                        id: row.id,
                        sort: row.sort,
                    }, {
                        token: true
                    })
                    .then(response => {
                        if (response.data.code == '200') {
                            that.begin()
                            that.$message({
                                showClose: true,
                                message: '列表排序成功',
                                type: 'success'
                            });
                        } else {
                           this.$message.error(response.data.msg);
                        }
                    })
                    .catch(error => {})
            },
            //新增数据
            addpart() {
                let that = this
                that.dialogAdd = true
                that.filterText = ''
                that.ruleForm.Addname = ''
                that.ruleForm.Addtop = ''
                that.ruleForm.Addsort = 50
                that.openkeys = []
                that.add_show()
                this.mapListeder=[]
                this.ruleFormed.lb_mapList=[]
            },
            // 新增的查询
            add_show() {
                let that = this
                axios
                    .post("/admin/KkysKnowledgeDisease/addDiseaseListShowSpace", {}, {
                        token: true
                    })
                    .then(response => {
                        if (response.data.code == '200') {
                            that.data = response.data.data.data
                        } else {
                            this.$message.error(response.data.msg);
                        }
                    })
                    .catch(error => {})
            },
            //新增的上级诊疗中心
            getnodeclick(data) {
                let that = this
                that.filterText = data.name
                that.ruleForm.Addtop = data.id
                that.openkeys = []
                that.$refs.tree.setCheckedKeys(that.openkeys);
            },
            //新增的查询
            search() {
                let that = this
                that.openkeys = []
                for (var i = 0; i < that.$refs.tree.store._getAllNodes().length; i++) {
                    that.$refs.tree.store._getAllNodes()[i].expanded = false;
                }
                var list = []
                if (that.filterText != "") {
                    axios
                        .post("/admin/KkysKnowledgeDisease/addDiseaseListShowSpace", {
                            keyword: that.filterText
                        }, {
                            token: true
                        })
                        .then(response => {
                            if (response.data.code == '200') {
                                var list = response.data.keyword_data
                                list.forEach(element => {
                                    if (element.name.includes(that.filterText)) {
                                        that.openkeys.push(element.id)
                                        that.$refs.tree.setCheckedKeys(that.openkeys);
                                    }
                                });
                            } else {
                                this.$message.error(response.data.msg);
                            }
                        })
                        .catch(error => {})
                }
            },
            //新增数据的提交
            addsub(formName) {
                let that = this
                that.$refs[formName].validate((valid) => {
                    if (valid) {
                        if (!that.ruleForm.Addtop.toString()) return this.$message.error('请选择上级诊疗中心');
                        this.subLoading=true
                        axios.post("/admin/KkysKnowledgeDisease/addDisease", {
                                pid: that.ruleForm.Addtop,
                                sort: that.ruleForm.Addsort,
                                name: that.ruleForm.Addname,
                                author: that.user.id,
                                file_info:this.mapListed
                            }, {
                                token: true
                            })
                            .then(response => {
                                 this.subLoading=false
                                if (response.data.code == '200') {
                                    that.begin()
                                    that.dialogAdd = false
                                    this.$refs[formName].resetFields();
                                    that.$message({
                                        showClose: true,
                                        message: '添加成功',
                                        type: 'success'
                                    });
                                } else {
                                        this.$message.error(response.data.msg);
                                }
                            })
                            .catch(error => {
                                 this.subLoading=false
                            })
                    }
                });
            },
            //编辑数据
            handleEdit(index, row) {
                let that = this
                that.dialogEdit = true
                that.eid = row.id
                that.Edit_show()
            },
            //编辑查询
            Edit_show() {
                let that = this
                var pid = ''
                that.openkeysed = []
                that.ruleFormed.Edittop = ''
                this.mapListeder=[]
                this.ruleFormed.lb_mapList=[]
                axios
                    .post("/admin/KkysKnowledgeDisease/editDisease", {
                        id: that.eid,
                    }, {
                        token: true
                    })
                    .then(response => {
                        if (response.data.code == '200') {
                            that.ruleFormed.Editname = response.data.data.name
                            that.ruleFormed.Edittop = response.data.data.pid
                            that.ruleFormed.Editsort = response.data.data.sort
                            that.ruleFormed.lb_mapList=that.mapListeder=response.data.data.file_info?response.data.data.file_info:[]
                            var pid = response.data.data.pid
                            axios
                                .post("/admin/KkysKnowledgeDisease/addDiseaseListShowSpace", {}, {
                                    token: true
                                })
                                .then(response => {
                                    if (response.data.code == '200') {
                                        that.dataed = response.data.data.data
                                        //递归
                                        var returnedItem;
                                        var find = function (arr, id) {
                                            arr.forEach(item => {
                                                if (item.id == id) {
                                                    returnedItem = item;
                                                    return item;
                                                } else if (item.children.length > 0) {
                                                    find(item.children, id);
                                                }
                                            })
                                        }
                                        var item = find(that.dataed, pid);
                                        that.filterTexted = returnedItem.name
                                        that.backshow(pid)
                                    } else {
                                       this.$message.error(response.data.msg);
                                    }
                                })
                                .catch(error => {})
                        } else {
                            this.$message.error(response.data.msg);
                        }
                    })
                    .catch(error => {})
            },
            //编辑的回显
            backshow(pid) {
                let that = this
                that.$nextTick(() => {
                    this.$refs.treed.setCurrentKey(pid)
                })
            },
            //编辑查询
            searched() {
                let that = this
                that.openkeysed = []
                var list = []
                if (that.filterTexted != "") {
                    axios
                        .post("/admin/KkysKnowledgeDisease/addDiseaseListShowSpace", {
                            keyword: that.filterTexted
                        }, {
                            token: true
                        })
                        .then(response => {
                            if (response.data.code == '200') {
                                var list = response.data.keyword_data
                                list.forEach(element => {
                                    if (element.name.includes(that.filterTexted)) {
                                        that.openkeysed.push(element.id)
                                        that.$refs.treed.setCheckedKeys(that.openkeysed);
                                    }
                                });
                            } else {
                                 this.$message.error(response.data.msg);
                            }
                        })
                        .catch(error => {})
                    for (var i = 0; i < that.$refs.treed.store._getAllNodes().length; i++) {
                        that.$refs.treed.store._getAllNodes()[i].expanded = false;
                    }
                }

            },
            getnodeclicked(data) {
                let that = this
                that.filterTexted = data.name
                that.ruleFormed.Edittop = data.id
                that.openkeysed = []
                that.$refs.treed.setCheckedKeys(that.openkeysed);
            },
            //编辑数据的提交
            Editsub(formName) {
                let that = this
                that.$refs[formName].validate((valid) => {
                    if (valid) {
                        if (!that.ruleFormed.Edittop.toString()) return this.$message.error('请选择上级诊疗中心');
                             this.subloadings=true
                            axios
                                .post("/admin/KkysKnowledgeDisease/editDiseaseSave", {
                                    id: that.eid,
                                    pid: that.ruleFormed.Edittop,
                                    sort: that.ruleFormed.Editsort,
                                    name: that.ruleFormed.Editname,
                                    author: that.user.id,
                                    file_info:this.mapListeder
                                }, {
                                    token: true
                                })
                                .then(response => {
                                     this.subloadings=false
                                    if (response.data.code == '200') {
                                        that.begin()
                                        that.dialogEdit = false
                                        this.$refs[formName].resetFields();
                                        this.$message({
                                            showClose: true,
                                            message: '编辑成功',
                                            type: 'success'
                                        });
                                    } else {
                                        this.$message.error(response.data.msg);
                                    }
                                })
                                .catch(error => {
                                     this.subloadings=false
                                })
                    }
                })
            },
            //添加子诊疗中心
            handlechild(index, row) {
                let that = this
                that.dialogchild = true
                that.child_id = row.id
                that.chil_name = row.name
                that.ruleFormer.childsort = 50
                that.ruleFormer.childname = ""
            },
            //添加子诊疗中心的提交
            Editchildsub(formName) {
                let that = this
                that.$refs[formName].validate((valid) => {
                    if (valid) {
                        axios
                            .post("/admin/KkysKnowledgeDisease/addDisease", {
                                pid: that.child_id,
                                sort: that.ruleFormer.childsort,
                                name: that.ruleFormer.childname,
                                author: that.user.id
                            }, {
                                token: true
                            })
                            .then(response => {
                                if (response.data.code == '200') {
                                    that.begin()
                                    that.dialogchild = false
                                    this.$refs[formName].resetFields();
                                    this.$message({
                                        showClose: true,
                                        message: '添加成功',
                                        type: 'success'
                                    });
                                } else {
                                    this.$message.error(response.data.msg);
                                }
                            })
                            .catch(error => {})
                    }
                })
            },
            //删除
            handleDelete(index, row) {
                let that = this
                this.$confirm('此操作将永久删除该信息, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    axios
                        .post("/admin/KkysKnowledgeDisease/delDisease", {
                            id: row.id,
                            delete_user: that.user.id
                        }, {
                            token: true
                        })
                        .then(response => {
                            if (response.data.code == '200') {
                                that.begin()
                                this.$message({
                                    type: 'success',
                                    message: '删除成功!'
                                });
                            } else {
                                 this.$message.error(response.data.msg);
                            }
                        })
                        .catch(error => {})
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
             // 添加
            uploadSuccess(response, file, fileList) {
                let that = this
                if (response.code == "201") {
                    that.$nextTick(() => {
                        let mainImg = that.$refs.upload;
                        if (mainImg) {
                            mainImg.uploadFiles.forEach((element, index) => {
                                if (file.uid == element.uid) {
                                    mainImg.uploadFiles.splice(index, 1)
                                }
                            });
                        }
                    })
                    that.$alert(response.msg)
                    return;
                }
                that.$message({ message: '上传成功', type: 'success' });
                that.mapListed.push(response.data)
            },
            uploadRmove(file, fileList) {
                this.mapListed = []
            },
            handlePictureCardPreview(file){
                this.dialogImageUrl = file.url;
                this.dialogVisible = true;
            },
             // 修改
            uploadSuccessed(response, file, fileList) {
                let that = this
                if (response.code == "201") {
                    that.$nextTick(() => {
                        let mainImg = that.$refs.uploads;
                        if (mainImg) {
                            mainImg.uploadFiles.forEach((element, index) => {
                                if (file.uid == element.uid) {
                                    mainImg.uploadFiles.splice(index, 1)
                                }
                            });
                        }
                    })
                    that.$alert(response.msg)
                    return;
                }
                that.$message({
                    message: '上传成功',
                    type: 'success'
                });
                that.mapListeder.push(response.data)
            },
            uploadRmoved(file, fileList) {
                this.mapListeder = []
            },
        },

    };
</script>

<style scoped>
    .listtree .el-tree-node.is-checked.is-expanded>.el-tree-node__content {
        background-color: #008080 !important;
        color: #ffffff !important;
    }

    .listtree .el-tree-node.is-current>.el-tree-node__content {
        background-color: #008080 !important;
        color: #ffffff !important;
    }

    .dia_over {
        width: 70%;
        height: 300px;
        overflow-x: hidden;
        overflow-y: scroll;
        border: 1px solid #ebeef5;
        border-radius: 3px;
        margin-top: 10px;
    }

    .dia_mg {
        margin: 10px
    }

    .tab_inp {
        max-width: 200px
    }
    .disabled /deep/ .el-upload--picture-card{
        display: none;
    }
</style>